import React, { Fragment, useState, useMemo, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Button, Modal } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import Select from "react-select";
import { ToastContainer } from "react-toastify";
import PageTitle from "../../layouts/PageTitle";
import Toastr from "../../components/common/Toastr";
import CommonService from "../../../services/Common/CommonService";
import { masterActions, orderActions } from "../../../_store";
import { fCurrency, fNumber } from "../../../utils/formatNumber";
import emptyImage from "../../../images/no-image-png-2.png";
import {
  restApi,
  restApi_PD,
} from "../../../services/wooCommerceRestApi/restApi";
const { REACT_APP_API_IMAGE_URL } = process.env;
const AddEditOrder = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const [loader, showLoader, hideLoader] = useFullPageLoader();

  const editOrderID = location.state ? location.state.OrderID : 0;

  // #region Reducers ------------------  Reducers --------------------------------
  const currentUser = useSelector((x) => x.auth.user);
  const clientDrpList = useSelector((x) => x.master.clientDrpList);
  const orderSourceDrpList = useSelector((x) => x.master.orderSourceDrpList);
  const categoryDrpList = useSelector((x) => x.master.categoryDrpList);
  const subCategoryDrpList = useSelector((x) => x.master.subCategoryDrpList);
  const productDetailDrpList = useSelector(
    (x) => x.master.productDetailDrpList
  );
  const orderSaveResponse = useSelector((x) => x.order.orderSaveResponse);
  const orderMessageResponse = useSelector((x) => x.order.orderMessageResponse);
  const orderDetail = useSelector((x) => x.order.orderDetail);

  // #endregion Reducers ------------------  Reducers End --------------------------------

  let styles = {
    control: (styles) => ({ ...styles, border: "1px solid red" }),
  };

  const [headerFormData, setHeaderFormData] = useState({
    OrderID: editOrderID,
    ClientID: 0,
    OrderSourceID: 0,
    CategoryID: 0,
    SubCategoryID: 0,
    ProductID: 0,
    GrandTotal: 0,
    ChildIsGemar: false,
    ChildIsPartyDeco: false,
    Status: 1,
    CreatedBy: currentUser.Id,
    TypeOrderProductModelList: [],
    ProductImage: "",
    Price: 0,
    AvailableQuantity: 0,
    OrderQuantity: 0,
    AllotedQuantity: 0,
    QuotaTrigger1: 0,
    QuotaTrigger2: 0,
    ClientTypeAndQuota: "",
    ClientOption: null,
    CategoryOption: null,
    SubCategoryOption: null,
    ProductOption: null,
    OrderSourceOption: null,
    AllowBackOrder: 0,
    IsBackOrder: false,
    IndexId: -1,
    IsGemar: false,
    IsPartyDeco: false,
    WCProductID: 0,
    PDWCProductID: 0,
    IsOrderCreated: false,
    IsOldOrderCreated: false,
    WCCustomerMessage: "",
    CustomerMessage: "",
    IsOrderMessage: false,
  });

  //Add data
  // const [OrderMessage, setOrderMessage] = useState();
  const [subCategoryList, setSubCategoryList] = useState([]);
  const [productList, setProductList] = useState([]);
  const [submitted, setSubmitted] = useState(false);
  const [IsShowWarningText, setIsShowWarningText] = useState(false);
  const [isCancelModal, setCancelModal] = useState(false);

  const newHeaderFormData = { ...headerFormData };

  // First Time Page data load
  useEffect(() => {
    dispatch(masterActions.GetOrderSourceList());

    let CategoryID = 0;
    let Status = 1;
    let ClientID = 0;
    let ProductID = 0;
    dispatch(masterActions.GetOrderProductDrpList({ ProductID, Status }));
    dispatch(masterActions.GetClientDrpList({ ClientID, Status }));
    dispatch(masterActions.GetCategoryDrpList({ CategoryID, Status }));

    let SubCategoryID = 0;
    dispatch(
      masterActions.GetSubCategoryDrpList({ CategoryID, SubCategoryID, Status })
    );

    if (editOrderID > 0) {
      dispatch(orderActions.GetOrderDetailsByID({ OrderID: editOrderID }));
      // isProductQuantityisZero(orderDetail?.OrderProductModelList);
    }
  }, [dispatch]);

  useEffect(() => {
    setProductList(productDetailDrpList);
  }, [productDetailDrpList]);

  // Order Edit data load
  useEffect(() => {
    if (orderDetail && orderDetail.OrderID > 0) {
      newHeaderFormData.OrderID = orderDetail.OrderID;
      newHeaderFormData.ClientID = orderDetail.ClientID;
      newHeaderFormData.OrderSourceID = orderDetail.OrderSourceID;

      newHeaderFormData.GrandTotal = orderDetail.GrandTotal;
      newHeaderFormData.ClientTypeAndQuota = orderDetail.ClientTypeAndQuota;
      newHeaderFormData.IsPartyDeco = orderDetail.IsPartyDeco;
      newHeaderFormData.IsOrderCreated = orderDetail.IsOrderCreated;
      newHeaderFormData.IsOldOrderCreated = orderDetail.IsOrderCreated;
      newHeaderFormData.WCCustomerMessage = orderDetail.WCCustomerMessage;
      newHeaderFormData.CustomerMessage = orderDetail.CustomerMessage;

      newHeaderFormData.ClientOption = {
        value: orderDetail.ClientID,
        label: orderDetail.ClientName,
      };
      newHeaderFormData.OrderSourceOption = {
        value: orderDetail.OrderSourceID,
        label: orderDetail.OrderSource,
      };

      newHeaderFormData.TypeOrderProductModelList =
        orderDetail.OrderProductModelList;

      newHeaderFormData.IndexId = -1;
      setHeaderFormData(newHeaderFormData);

      //hideLoader();
      isProductQuantityisZero(orderDetail?.OrderProductModelList);
    }
  }, [orderDetail]);

  // handle Change function
  const handleChange = (event) => {
    const regexString = /^[a-zA-Z\s]*$/;
    const regexNumber = /^[0-9\b]+$/;
    const fieldName = event.target.getAttribute("name");
    const fieldValue = event.target.value;
    if (fieldValue && fieldValue.trim()) {
      if (fieldName === "OrderQuantity" || fieldName === "AllotedQuantity") {
        if (!newHeaderFormData.ClientOption) {
          Toastr("Select Client", "warning");
        } else if (!newHeaderFormData.CategoryOption) {
          Toastr("Select Category", "warning");
        } else if (!newHeaderFormData.SubCategoryOption) {
          Toastr("Select Sub Category", "warning");
        } else if (!newHeaderFormData.ProductOption) {
          Toastr("Select Product", "warning");
        } else {
          if (fieldValue === "" || regexNumber.test(fieldValue)) {
            newHeaderFormData[fieldName] = fieldValue;
          }
        }
      } else {
        newHeaderFormData[fieldName] = fieldValue;
      }
    } else {
      newHeaderFormData[fieldName] = fieldValue.trim();
    }

    setHeaderFormData(newHeaderFormData);
  };

  const isProductQuantityisZero = (OrderList) => {
    const keyExist = OrderList.some((obj) => obj.hasOwnProperty("IsAPIError"));
    const isError = keyExist
      ? OrderList.some((obj) => obj.IsAPIError === true)
      : false;
    setIsShowWarningText(isError);
  };

  // handle Dropdown Change function
  const handleDrpChange = (event, title) => {
    newHeaderFormData[title] = event.value && parseInt(event.value);
    if (title === "ClientID") {
      newHeaderFormData.ClientOption = {
        value: parseInt(event.value),
        label: event.label,
      };
      newHeaderFormData.ClientTypeAndQuota =
        event.ClientTypeName + " / " + event.ClientQuotaName;

      newHeaderFormData.CategoryOption = null;
      newHeaderFormData.SubCategoryOption = null;
      newHeaderFormData.ProductOption = null;
      newHeaderFormData.AvailableQuantity = 0;
      newHeaderFormData.OrderQuantity = 0;
      newHeaderFormData.AllotedQuantity = 0;
    } else if (title === "OrderSourceID") {
      newHeaderFormData.OrderSourceOption = {
        value: parseInt(event.value),
        label: event.label,
      };
    } else if (title === "CategoryID") {
      newHeaderFormData.CategoryOption = {
        value: parseInt(event.value),
        label: event.label,
      };

      if (event.value && parseInt(event.value) > 0) {
        let subCategory = [...subCategoryDrpList];
        subCategory = subCategory.filter(
          (d) => d.parentId === parseInt(event.value)
        );
        setSubCategoryList(subCategory);
        newHeaderFormData.SubCategoryOption = null;
        newHeaderFormData.ProductOption = null;
        newHeaderFormData.AvailableQuantity = 0;
        newHeaderFormData.OrderQuantity = 0;
        newHeaderFormData.AllotedQuantity = 0;
      }
    } else if (title === "SubCategoryID") {
      newHeaderFormData.SubCategoryOption = {
        value: parseInt(event.value),
        label: event.label,
      };
      if (event.value && parseInt(event.value) > 0) {
        let productList = [...productDetailDrpList];
        productList = productList.filter(
          (d) => d.parentId === parseInt(event.value)
        );
        setProductList(productList);
        newHeaderFormData.ProductOption = null;
        newHeaderFormData.AvailableQuantity = 0;
        newHeaderFormData.OrderQuantity = 0;
        newHeaderFormData.AllotedQuantity = 0;
      }
    } else if (title === "ProductID") {
      if (newHeaderFormData && newHeaderFormData.ClientOption) {
        newHeaderFormData.ProductOption = {
          value: parseInt(event.value),
          label: event.label,
        };

        let productList = [...productDetailDrpList];
        productList = productList.find(
          (d) => d.value === parseInt(event.value)
        );

        newHeaderFormData.CategoryOption = {
          value: productList.CategoryID,
          label: productList.CategoryName,
        };
        newHeaderFormData.SubCategoryOption = {
          value: productList.SubCategoryID,
          label: productList.SubCategoryName,
        };

        if (event.value && parseInt(event.value) > 0) {
          CommonService.GetProductDetailsByID({
            ProductID: parseInt(event.value),
          }).then((res) => {
            if (res.data) {
              let result = res.data;
              let clientList = [...clientDrpList];
              let clientRow = clientList.filter(
                (d) => d.value === newHeaderFormData.ClientOption.value
              );
              let ProductImage =
                result &&
                result.ProductImageModelList &&
                result.ProductImageModelList.length > 0 &&
                result.ProductImageModelList[0].ImageFilePath;

              if (ProductImage) {
                newHeaderFormData.ProductImage = ProductImage;
              } else {
                newHeaderFormData.ProductImage = "";
              }

              if (clientRow && clientRow[0]) {
                let clientTypeID = clientRow[0].ClientTypeID;
                if (clientTypeID === 1) {
                  // GASSOCIATE
                  newHeaderFormData.Price = result.GAssociatePrice;
                } else if (clientTypeID === 2) {
                  // GSTAR
                  newHeaderFormData.Price = result.GStarPrice;
                } else if (clientTypeID === 3) {
                  // GVENDOR
                  newHeaderFormData.Price = result.GVendorPrice;
                } else if (clientTypeID === 4) {
                  // PARTNER
                  newHeaderFormData.Price = result.GPARTNERPrice;
                } else if (clientTypeID === 5) {
                  // PFA
                  newHeaderFormData.Price = result.PFAPrice;
                } else if (clientTypeID === 6) {
                  // PartyDecoPrice
                  newHeaderFormData.Price = result.PartyDecoPrice;
                }
                newHeaderFormData.QuotaTrigger1 = result.QuotaTrigger1;
                newHeaderFormData.QuotaTrigger2 = result.QuotaTrigger2;
                newHeaderFormData.AllowBackOrder = result.AllowBackOrder;
                newHeaderFormData.AvailableQuantity = result.StockQuantity;
                newHeaderFormData.OrderQuantity = 0;
                newHeaderFormData.AllotedQuantity = 0;
                newHeaderFormData.ChildIsGemar = result.IsGemar;
                newHeaderFormData.ChildIsPartyDeco = result.IsPartyDeco;

                newHeaderFormData.WCProductID = result.WCProductID;
                newHeaderFormData.PDWCProductID = result.PDWCProductID;
                setHeaderFormData(newHeaderFormData);
              }

              // newHeaderFormData[title] = hasChecked;
              // setHeaderFormData(newHeaderFormData);
              //  hideLoader();
            } else {
              // Toastr('This Attribute is already mapped', "warning");
              // hideLoader();
            }
          });

          // const newHeaderFormData = { ...headerFormData };
          // let priceList = [...clientDrpList];
          // priceList = priceList.filter(d => d.parentId === parseInt(event.value));
          // if (priceList) {
          //     newHeaderFormData.Price = ""
          // }
          // setProductList(priceList);
        }
      } else {
        Toastr("Please select client name ", "warning");
      }
    }
    if (title !== "ProductID") {
      setHeaderFormData(newHeaderFormData);
    }
  };

  // handle Blur
  const handleBlur = (event) => {
    const fieldName = event.target.getAttribute("name");
    let fieldValue = event.target.value;
    let AvailableQuantity = parseInt(newHeaderFormData.AvailableQuantity);
    if (fieldValue && fieldValue.trim()) {
      if (fieldName === "OrderQuantity") {
        if (fieldValue) {
          let AllotedQuantity = 0;
          let qtyValue = parseInt(fieldValue);
          if (
            newHeaderFormData.QuotaTrigger2 >= AvailableQuantity &&
            AvailableQuantity > 0
          ) {
            //QuotaTrigger 2

            let clientRow = clientDrpList.filter(
              (d) => d.value === newHeaderFormData.ClientOption.value
            );
            if (clientRow && clientRow[0]) {
              let TriggerPercentage2 = clientRow[0].TriggerPercentage2;
              AllotedQuantity =
                (newHeaderFormData.AvailableQuantity / 100) *
                TriggerPercentage2;
            }
          } else if (
            (newHeaderFormData.QuotaTrigger2 < AvailableQuantity &&
              AvailableQuantity > 0 &&
              newHeaderFormData.QuotaTrigger1 >= AvailableQuantity) ||
            (AvailableQuantity > 0 && AvailableQuantity < qtyValue)
          ) {
            //QuotaTrigger 1
            let clientRow = clientDrpList.filter(
              (d) => d.value === newHeaderFormData.ClientOption.value
            );
            if (clientRow && clientRow[0]) {
              let TriggerPercentage1 = clientRow[0].TriggerPercentage1;
              AllotedQuantity =
                (newHeaderFormData.AvailableQuantity / 100) *
                TriggerPercentage1;
            }
          } else {
            if (
              newHeaderFormData.AllowBackOrder === 1 &&
              AvailableQuantity < 1
            ) {
              AllotedQuantity = 0;
              Toastr("Backorders are not allowed", "warning");
            } else if (newHeaderFormData.AllowBackOrder !== 0) {
              AllotedQuantity = qtyValue;
            }
          }

          newHeaderFormData[fieldName] = fieldValue;

          if (
            AllotedQuantity < qtyValue ||
            (parseInt(newHeaderFormData.AvailableQuantity) < qtyValue &&
              0 < parseInt(newHeaderFormData.AvailableQuantity))
          ) {
            newHeaderFormData.AllotedQuantity = Math.round(AllotedQuantity);
          } else if (AllotedQuantity >= qtyValue && qtyValue > 0) {
            newHeaderFormData.AllotedQuantity = qtyValue;
          } else {
            if (newHeaderFormData.AllowBackOrder === 1) {
              newHeaderFormData.AllotedQuantity = 0;
            } else if (newHeaderFormData.AllowBackOrder !== 0) {
              newHeaderFormData.AllotedQuantity = qtyValue;
            }
          }

          // if ((AllotedQuantity < qtyValue) || (parseInt(newHeaderFormData.AvailableQuantity) < qtyValue && 0 < parseInt(newHeaderFormData.AvailableQuantity))) {
          //     newHeaderFormData.AllotedQuantity = Math.round(AllotedQuantity);
          // } else {
          //     if (newHeaderFormData.AllowBackOrder === 1) {
          //         newHeaderFormData.AllotedQuantity = 0;

          //     } else if (newHeaderFormData.AllowBackOrder !== 0) {
          //         newHeaderFormData.AllotedQuantity = qtyValue;
          //     }
          // }
          setHeaderFormData(newHeaderFormData);
        }
      } else if (fieldName === "AllotedQuantity") {
        if (fieldValue) {
          let qtyValue = parseInt(fieldValue);

          if (AvailableQuantity >= qtyValue) {
            newHeaderFormData.AllotedQuantity = qtyValue;
          } else if (newHeaderFormData.AllowBackOrder === 1) {
            newHeaderFormData.AllotedQuantity = 0;
            Toastr("Backorders are not allowed", "warning");
          } else {
            newHeaderFormData.AllotedQuantity = qtyValue;
          }
        }
        setHeaderFormData(newHeaderFormData);
      }
    } else {
      newHeaderFormData.AllotedQuantity = 0;
      setHeaderFormData(newHeaderFormData);
    }
    //dispatch(productActions.tempSetProductTabData(newFormData));
  };

  //handle Edit Order Product
  const handleEditOrder = (index, OrderProductID) => {
    setSubmitted(false);
    let editOrderRow = newHeaderFormData.TypeOrderProductModelList[index];
    newHeaderFormData.IndexId = index;
    newHeaderFormData.CategoryOption = {
      value: editOrderRow.CategoryID,
      label: editOrderRow.CategoryName,
    };
    newHeaderFormData.SubCategoryOption = {
      value: editOrderRow.SubCategoryID,
      label: editOrderRow.SubCategoryName,
    };
    newHeaderFormData.ProductOption = {
      value: editOrderRow.ProductID,
      label: editOrderRow.ProductName,
    };
    newHeaderFormData.ProductImage = editOrderRow.ProductImage;
    if (OrderProductID > 0) {
      let productRow =
        orderDetail &&
        orderDetail.OrderProductModelList.filter(
          (d) => d.ProductID === newHeaderFormData.ProductOption.value
        );
      if (productRow && productRow.length > 0) {
        newHeaderFormData.AvailableQuantity =
          productRow[0].AvailableQuantity + productRow[0].Quantity;
      } else {
        newHeaderFormData.AvailableQuantity = editOrderRow.AvailableQuantity;
      }
    } else {
      newHeaderFormData.AvailableQuantity = editOrderRow.AvailableQuantity;
    }

    newHeaderFormData.Price = editOrderRow.UnitPrice;
    newHeaderFormData.OrderQuantity = editOrderRow.OrderQuantity;
    newHeaderFormData.AllotedQuantity = editOrderRow.Quantity;
    newHeaderFormData.AllowBackOrder = editOrderRow.AllowBackOrder;
    newHeaderFormData.QuotaTrigger1 = editOrderRow.QuotaTrigger1;
    newHeaderFormData.QuotaTrigger2 = editOrderRow.QuotaTrigger2;
    newHeaderFormData.ChildIsGemar = editOrderRow.IsGemar;
    newHeaderFormData.ChildIsPartyDeco = editOrderRow.IsPartyDeco;

    newHeaderFormData.WCProductID = editOrderRow.WCProductID;
    newHeaderFormData.PDWCProductID = editOrderRow.PDWCProductID;
    // }
    setHeaderFormData(newHeaderFormData);
  };

  //handle Add And Update Order Product
  const handleAddProduct = () => {
    if (
      newHeaderFormData.OrderQuantity &&
      newHeaderFormData.OrderQuantity > 0 &&
      newHeaderFormData.AllotedQuantity &&
      newHeaderFormData.AllotedQuantity > 0 &&
      newHeaderFormData.OrderSourceID > 0
    ) {
      let productRow = newHeaderFormData.TypeOrderProductModelList.filter(
        (d) =>
          d.ProductID === newHeaderFormData.ProductOption.value &&
          d.IsDeleted === false
      );
      let isExiting = false;

      if (
        productRow &&
        productRow.length > 0 &&
        newHeaderFormData.IndexId > -1
      ) {
        let editRow =
          newHeaderFormData.TypeOrderProductModelList[
            newHeaderFormData.IndexId
          ];
        if (editRow.ProductID === newHeaderFormData.ProductOption.value) {
          isExiting = true;
        }
      }

      if (!productRow || productRow.length < 1 || isExiting === true) {
        let total = newHeaderFormData.Price * newHeaderFormData.AllotedQuantity;

        let newProduct = {
          OrderProductID: 0,
          CategoryID: newHeaderFormData.CategoryOption.value,
          CategoryName: newHeaderFormData.CategoryOption.label,
          SubCategoryID: newHeaderFormData.SubCategoryOption.value,
          SubCategoryName: newHeaderFormData.SubCategoryOption.label,
          ProductID: newHeaderFormData.ProductOption.value,
          ProductName: newHeaderFormData.ProductOption.label,
          OrderQuantity: newHeaderFormData.OrderQuantity,
          UnitPrice: newHeaderFormData.Price,
          AvailableQuantity: newHeaderFormData.AvailableQuantity,
          ProductImage: newHeaderFormData.ProductImage,
          Quantity: newHeaderFormData.AllotedQuantity,
          AllowBackOrder: newHeaderFormData.AllowBackOrder,
          Total: total,
          ProductStatus: 1,
          IsDeleted: false,
          QuotaTrigger1: newHeaderFormData.QuotaTrigger1,
          QuotaTrigger2: newHeaderFormData.QuotaTrigger2,
          IsBackOrder: newHeaderFormData.AvailableQuantity <= 0 ? true : false,
          IsGemar: newHeaderFormData.ChildIsGemar,
          IsPartyDeco: newHeaderFormData.ChildIsPartyDeco,
          WCProductID: newHeaderFormData.WCProductID,
          PDWCProductID: newHeaderFormData.PDWCProductID,
        };
        let typeOrderProductList = [
          ...newHeaderFormData.TypeOrderProductModelList,
        ];

        if (newHeaderFormData.IndexId === -1) {
          typeOrderProductList.push(newProduct);
          newHeaderFormData.TypeOrderProductModelList = [
            ...typeOrderProductList,
          ];
        } else {
          newProduct.OrderProductID =
            typeOrderProductList[newHeaderFormData.IndexId].OrderProductID;
          newProduct.AvailableQuantity =
            typeOrderProductList[newHeaderFormData.IndexId].AvailableQuantity;
          typeOrderProductList[newHeaderFormData.IndexId] = { ...newProduct };

          newHeaderFormData.TypeOrderProductModelList = [
            ...typeOrderProductList,
          ];
        }

        newHeaderFormData.CategoryOption = null;
        newHeaderFormData.SubCategoryOption = null;
        newHeaderFormData.ProductOption = null;
        // newHeaderFormData.OrderSourceOption = null;
        newHeaderFormData.OrderQuantity = 0;
        newHeaderFormData.ProductImage = null;
        newHeaderFormData.Price = 0;
        newHeaderFormData.AvailableQuantity = 0;
        newHeaderFormData.AllotedQuantity = 0;
        newHeaderFormData.QuotaTrigger1 = 0;
        newHeaderFormData.QuotaTrigger2 = 0;

        newHeaderFormData.IndexId = -1;
        let grandTotal = 0;
        newHeaderFormData.TypeOrderProductModelList.filter(
          (d) => d.IsDeleted === false
        ).map(
          (current) =>
            (grandTotal =
              grandTotal + parseFloat(current.Total ? current.Total : 0))
        );

        newHeaderFormData.GrandTotal = grandTotal;

        setHeaderFormData(newHeaderFormData);
        setSubmitted(false);
        isProductQuantityisZero(newHeaderFormData?.TypeOrderProductModelList);
      } else {
        Toastr("This Product already exists", "warning");
      }
    } else {
      setSubmitted(true);
      Toastr(
        " Please fill in the required missing fields or Allotted Quantity should not be Zero",
        "warning"
      );
    }
  };

  const handleRemoveOrder = (index, OrderProductID) => {
    if (OrderProductID > 0) {
      const allRowData = [...newHeaderFormData.TypeOrderProductModelList];
      const rowData = { ...allRowData[index] };
      rowData.IsDeleted = true;
      const allRowDataflt = allRowData.filter(
        (d) => d.OrderProductID !== OrderProductID
      );
      allRowDataflt.push(rowData);
      newHeaderFormData.TypeOrderProductModelList = allRowDataflt;
    } else {
      newHeaderFormData.TypeOrderProductModelList.splice(index, 1);
    }
    if (
      newHeaderFormData.TypeOrderProductModelList &&
      newHeaderFormData.TypeOrderProductModelList.filter(
        (d) => d.IsDeleted === false
      ).length > 0
    ) {
      let grandTotal = 0;
      newHeaderFormData.TypeOrderProductModelList.filter(
        (d) => d.IsDeleted === false
      ).map(
        (current) =>
          (grandTotal =
            grandTotal + parseFloat(current.Total ? current.Total : 0))
      );

      newHeaderFormData.GrandTotal = grandTotal;
    } else {
      newHeaderFormData.GrandTotal = 0;
    }

    setHeaderFormData(newHeaderFormData);
  };

  // Submit data function
  const handleSubmit = (event, title) => {
    if (
      newHeaderFormData.TypeOrderProductModelList &&
      newHeaderFormData.TypeOrderProductModelList.length > 0 &&
      newHeaderFormData.TypeOrderProductModelList.filter(
        (d) => d.IsDeleted === false
      ).length > 0
    ) {
      showLoader();
      let gemar_data = [];
      let PD_data = [];
      let iserror = false;
      newHeaderFormData.TypeOrderProductModelList.map((model) => {
        let oldQuantity = 0;
        let newQuantity = model.Quantity;
        let lastQuantity = 0;
        let availQty = 0;
        if (model.OrderProductID && model.OrderProductID > 0) {
          let productRow =
            orderDetail &&
            orderDetail.OrderProductModelList.filter(
              (d) => d.OrderProductID === model.OrderProductID
            );
          if (productRow && productRow.length > 0) {
            oldQuantity = productRow[0].Quantity;
          }
          if (!(model.IsDeleted === true)) {
            if (oldQuantity < newQuantity) {
              lastQuantity = parseInt(newQuantity) - parseInt(oldQuantity);
              availQty = parseInt(model.AvailableQuantity) - lastQuantity;
            } else if (oldQuantity > newQuantity) {
              lastQuantity = parseInt(oldQuantity) - parseInt(newQuantity);
              availQty = parseInt(model.AvailableQuantity) + lastQuantity;
            } else {
              availQty = parseInt(model.AvailableQuantity);
            }
          } else {
            availQty = parseInt(model.AvailableQuantity) + oldQuantity;
          }

          if (model.IsAPIError === true && !model.IsDeleted === true) {
            iserror = true;
          }
        } else {
          availQty =
            parseInt(model.AvailableQuantity) - parseInt(model.Quantity);
        }

        if (model.IsGemar === true) {
          let data = {
            id: model.WCProductID,
            stock_quantity: availQty,
          };

          gemar_data.push(data);
        }

        if (model.IsPartyDeco === true) {
          let data = {
            id: model.PDWCProductID,
            stock_quantity: availQty,
          };
          PD_data.push(data);
        }
      });
      if (iserror === true && title === true) {
        hideLoader();
        Toastr("Insufficient product quantity.Kindly modify", "warning");
        return false;
      } else {
        newHeaderFormData.IsOldOrderCreated = newHeaderFormData.IsOrderCreated;
        newHeaderFormData.IsOrderCreated = title;

        if (
          gemar_data &&
          gemar_data.length > 0 &&
          PD_data &&
          PD_data.length > 0
        ) {
          AddUpdateOrder_GemarAndPD(gemar_data, PD_data);
        } else if (gemar_data && gemar_data.length > 0) {
          AddUpdateOrder_Gemar(gemar_data);
        } else if (PD_data && PD_data.length > 0) {
          AddUpdateOrder_PD(PD_data);
        } else {
          hideLoader();
        }
      }
    } else {
      Toastr("Please Add Atleast  anyone Product", "warning");
    }
  };

  // function AddUpdateOrder_GemarAndPD(gemar_data, PD_data) {
  //
  //   let gemarData = {
  //     update: gemar_data,
  //   };
  //   let PDData = {
  //     update: PD_data,
  //   };

  //   restApi
  //     .post("products/batch", gemarData) // Gemar API
  //     .then((response) => {
  //       if (
  //         response.status === 200 ||
  //         response.status === 201 ||
  //         !response.statusText
  //       ) {
  //         restApi_PD
  //           .put("products/batch", PDData) // Party Deco API
  //           .then((PDResponse) => {
  //             if (
  //               PDResponse.status === 200 ||
  //               PDResponse.status === 201 ||
  //               !PDResponse.statusText
  //             ) {
  //               dispatch(orderActions.saveOrder(newHeaderFormData));
  //             } else {
  //               hideLoader();
  //               Toastr(PDResponse.statusText, "warning");
  //             }
  //           })
  //           .catch((error) => {
  //             hideLoader();
  //             let msg = "";
  //             if (error.response) {
  //               msg = error.response.data.message;
  //             } else {
  //               msg = "rest Api error";
  //             }
  //             Toastr(msg, "warning");
  //           });
  //       } else {
  //         hideLoader();
  //         Toastr(response.statusText, "warning");
  //       }
  //     })
  //     .catch((error) => {
  //       hideLoader();
  //       let msg = "";
  //       if (error.response) {
  //         msg = error.response.data.message;
  //       } else {
  //         msg = "rest Api error";
  //       }
  //       Toastr(msg, "warning");
  //     });
  // }

  function AddUpdateOrder_GemarAndPD(gemar_data, PD_data) {
    const batchSize = 200; // Define the batch size
    let gemarPage = 0;
    let PDPage = 0;
    let totalGemarPages = Math.ceil(gemar_data.length / batchSize);
    let totalPDPages = Math.ceil(PD_data.length / batchSize);

    // Function to update a batch for Gemar API
    const updateGemarBatch = (batchData, page) => {
      let gemarData = {
        update: batchData,
      };

      restApi
        .post("products/batch", gemarData) // Gemar API
        .then((response) => {
          if (
            response.status === 200 ||
            response.status === 201 ||
            !response.statusText
          ) {
            if (page < totalGemarPages - 1) {
              // Move to the next Gemar batch
              gemarPage++;
              sendNextGemarBatch(gemarPage);
            } else {
              // Once Gemar batches are done, proceed to Party Deco API
              sendNextPDBatch(PDPage);
            }
          } else {
            hideLoader();
            Toastr(response.statusText, "warning");
          }
        })
        .catch((error) => {
          hideLoader();
          let msg = error.response
            ? error.response.data.message
            : "rest Api error";
          Toastr(msg, "warning");
        });
    };

    // Function to update a batch for Party Deco API
    const updatePDBatch = (batchData, page) => {
      let PDData = {
        update: batchData,
      };

      restApi_PD
        .put("products/batch", PDData) // Party Deco API
        .then((PDResponse) => {
          if (
            PDResponse.status === 200 ||
            PDResponse.status === 201 ||
            !PDResponse.statusText
          ) {
            if (page < totalPDPages - 1) {
              // Move to the next Party Deco batch
              PDPage++;
              sendNextPDBatch(PDPage);
            } else {
              // All batches processed, dispatch save order action
              dispatch(orderActions.saveOrder(newHeaderFormData));
            }
          } else {
            hideLoader();
            Toastr(PDResponse.statusText, "warning");
          }
        })
        .catch((error) => {
          hideLoader();
          let msg = error.response
            ? error.response.data.message
            : "rest Api error";
          Toastr(msg, "warning");
        });
    };

    // Function to send the next batch of Gemar data
    const sendNextGemarBatch = (page) => {
      let start = page * batchSize;
      let end = start + batchSize;
      let batchData = gemar_data.slice(start, end); // Get the next Gemar batch

      if (batchData.length > 0) {
        updateGemarBatch(batchData, page);
      }
    };

    // Function to send the next batch of Party Deco data
    const sendNextPDBatch = (page) => {
      let start = page * batchSize;
      let end = start + batchSize;
      let batchData = PD_data.slice(start, end); // Get the next Party Deco batch

      if (batchData.length > 0) {
        updatePDBatch(batchData, page);
      }
    };

    // Start by sending the first batch for Gemar API
    if (gemar_data.length > 0) {
      showLoader(); // Display loader while processing
      sendNextGemarBatch(gemarPage); // Start with Gemar API
    } else if (PD_data.length > 0) {
      // If no Gemar data but Party Deco data exists, process Party Deco directly
      sendNextPDBatch(PDPage);
    } else {
      hideLoader();
      Toastr("No data to update", "warning");
    }
  }

  function AddUpdateOrder_Gemar(gemar_data) {
    // Maximum items per batch (pagination)
    const batchSize = 200;
    let page = 0; // Track the current page
    let totalPages = Math.ceil(gemar_data.length / batchSize); // Calculate total pages

    // Function to update the order for each batch
    const updateBatch = (batchData, page) => {
      let gemarData = {
        update: batchData,
      };

      // Send the API request for the current batch
      restApi
        .post("products/batch", gemarData) // Gemar API
        .then((response) => {
          if (
            response.status === 200 ||
            response.status === 201 ||
            !response.statusText
          ) {
            if (page < totalPages - 1) {
              // Move to the next page/batch
              page++;
              sendNextBatch(page);
            } else {
              // All batches completed, dispatch save order action
              dispatch(orderActions.saveOrder(newHeaderFormData));
            }
          } else {
            hideLoader();
            Toastr(response.statusText, "warning");
          }
        })
        .catch((error) => {
          hideLoader();
          let msg = "";
          if (error.response) {
            msg = error.response.data.message;
          } else {
            msg = "rest Api error";
          }
          Toastr(msg, "warning");
        });
    };

    // Function to send the next batch of data
    const sendNextBatch = (page) => {
      let start = page * batchSize;
      let end = start + batchSize;
      let batchData = gemar_data.slice(start, end); // Get the next batch of data

      // Send batch to the API
      updateBatch(batchData, page);
    };

    // Start by sending the first batch
    if (gemar_data.length > 0) {
      showLoader(); // Display loader while processing
      sendNextBatch(page); // Start with the first page
    } else {
      Toastr("No data to update", "warning");
    }
  }

  function AddUpdateOrder_PD(PD_data) {
    // Maximum items per batch (pagination)
    const batchSize = 200;
    let page = 0; // Track the current page
    let totalPages = Math.ceil(PD_data.length / batchSize); // Calculate total pages

    // Function to update the order for each batch
    const updateBatch = (batchData, page) => {
      let PDData = {
        update: batchData,
      };

      // Send the API request for the current batch
      restApi_PD
        .put("products/batch", PDData) // Party Deco API
        .then((PDResponse) => {
          if (
            PDResponse.status === 200 ||
            PDResponse.status === 201 ||
            !PDResponse.statusText
          ) {
            if (page < totalPages - 1) {
              // Move to the next page/batch
              page++;
              sendNextBatch(page);
            } else {
              // All batches completed, dispatch save order action
              dispatch(orderActions.saveOrder(newHeaderFormData));
            }
          } else {
            hideLoader();
            Toastr(PDResponse.statusText, "warning");
          }
        })
        .catch((error) => {
          hideLoader();
          let msg = "";
          if (error.response) {
            msg = error.response.data.message;
          } else {
            msg = "rest Api error";
          }
          Toastr(msg, "warning");
        });
    };

    // Function to send the next batch of data
    const sendNextBatch = (page) => {
      let start = page * batchSize;
      let end = start + batchSize;
      let batchData = PD_data.slice(start, end); // Get the next batch of data

      // Send batch to the API
      updateBatch(batchData, page);
    };

    // Start by sending the first batch
    if (PD_data.length > 0) {
      showLoader(); // Display loader while processing
      sendNextBatch(page); // Start with the first page
    } else {
      Toastr("No data to update", "warning");
    }
  }

  //save temp Product
  const handleTemporarySave = (event, title) => {
    if (
      newHeaderFormData.TypeOrderProductModelList &&
      newHeaderFormData.TypeOrderProductModelList.length > 0 &&
      newHeaderFormData.TypeOrderProductModelList.filter(
        (d) => d.IsDeleted === false
      ).length > 0
    ) {
      showLoader();
      let iserror = false;
      newHeaderFormData.TypeOrderProductModelList.map((model) => {
        let oldQuantity = 0;
        let newQuantity = model.Quantity;
        let lastQuantity = 0;
        let availQty = 0;
        if (model.OrderProductID && model.OrderProductID > 0) {
          let productRow =
            orderDetail &&
            orderDetail.OrderProductModelList.filter(
              (d) => d.OrderProductID === model.OrderProductID
            );
          if (productRow && productRow.length > 0) {
            oldQuantity = productRow[0].Quantity;
          }
          if (!(model.IsDeleted === true)) {
            if (oldQuantity < newQuantity) {
              lastQuantity = parseInt(newQuantity) - parseInt(oldQuantity);
              availQty = parseInt(model.AvailableQuantity) - lastQuantity;
            } else if (oldQuantity > newQuantity) {
              lastQuantity = parseInt(oldQuantity) - parseInt(newQuantity);
              availQty = parseInt(model.AvailableQuantity) + lastQuantity;
            } else {
              availQty = parseInt(model.AvailableQuantity);
            }
          } else {
            availQty = parseInt(model.AvailableQuantity) + oldQuantity;
          }

          if (model.IsAPIError === true && !model.IsDeleted === true) {
            iserror = true;
          }
        } else {
          availQty =
            parseInt(model.AvailableQuantity) - parseInt(model.Quantity);
        }
      });

      newHeaderFormData.IsOldOrderCreated = newHeaderFormData.IsOrderCreated;
      newHeaderFormData.IsOrderCreated = title;
      newHeaderFormData.OrderSourceID = 1;

      dispatch(orderActions.saveOrder(newHeaderFormData));
    } else {
      Toastr("Please add any one product", "warning");
    }
  };
  const handleMessageOrder = (orderDetail) => {
    newHeaderFormData.OrderID = orderDetail.OrderID;
    newHeaderFormData.OrderNumber = orderDetail.OrderNumber;
    newHeaderFormData.ClientID = orderDetail.ClientID;
    setCancelModal(true);
    setSubmitted(false);
  };
  // close popup
  const handleClosePopup = () => {
    dispatch(orderActions.clearOrderResponse());
    setCancelModal(false);
  };
  // handle orderMessage Change function
  const handleOrderChange = (event) => {
    event.preventDefault();
    const regexString = /^[a-zA-Z\s]*$/;
    const regexNumber = /^[0-9\b]+$/;
    const fieldName = event.target.getAttribute("name");
    const fieldValue = event.target.value;
    if (fieldValue && fieldValue.trim()) {
      if (fieldName === "CustomerMessage") {
        if (fieldValue === "" || regexString.test(fieldValue)) {
          newHeaderFormData[fieldName] = fieldValue;
        } else {
          newHeaderFormData[fieldName] = fieldValue;
        }
      }
    } else {
      newHeaderFormData[fieldName] = fieldValue.trim();
    }
    setHeaderFormData(newHeaderFormData);
  };

  //Order Message  Submit
  const handleMessageSubmit = (event) => {
    event.preventDefault();
    var error = false;
    if (!newHeaderFormData.CustomerMessage) {
      error = true;
      Toastr("Please fill in the required missing fields", "warning");
    }
    if (!error) {
      dispatch(orderActions.saveOrder(newHeaderFormData));
      setCancelModal(false);
    }
  };

  // Product Add And Update
  useEffect(() => {
    if (orderSaveResponse === 1) {
      hideLoader();

      navigate("/OrderList");
    } else if (orderSaveResponse === 2) {
      hideLoader();
      // Toastr('Product updated successfully', "success");
      navigate("/OrderList");
    } else if (orderSaveResponse === -1) {
      hideLoader();
      Toastr("Order already exists ", "warning");
    } else if (orderSaveResponse < -1) {
      hideLoader();
      Toastr("order error ", "warning");
    } else if (
      orderSaveResponse &&
      orderSaveResponse.error &&
      orderSaveResponse.error.message
    ) {
      hideLoader();
      Toastr(orderSaveResponse.error.message, "warning");
    }
  }, [orderSaveResponse]);
  const handlechanges = () => {
    navigate("/OrderList");
  };

  ///Order Message  Update
  useEffect(() => {
    if (orderMessageResponse === 1) {
      dispatch(orderActions.clearOrderResponse());
      Toastr("Messsage  Send successfully", "success");
      dispatch(
        orderActions.GetOrderList({
          OrderID: 0,
          ClientID: 0,
          OrderSourceID: 0,
          Status: 1,
          OrderStatusID: 0,
          UserID: currentUser.Id,
          UserTypeID: currentUser.UserTypeID,
        })
      );
      // setPaymentModal(false);
      // setSubmitted(false);
      // SetPaymentData(newAddPaymentData);
    }
  }, [orderMessageResponse]);

  //   const handleBulkAdd= () => {
  // let params={WarehouseID:165
  //   ,CategoryID:171
  //   ,SubCategoryID:109
  //   ,Status:1
  // }
  //     CommonService.GetProductDetails(params).then((res) => {
  //       if (res?.data) {
  //
  //         let dataList = res.data;
  //         let typeOrderProductList = [];

  //       dataList.map((model) => {
  //     let total = model.GStarPrice * 1;

  //     let newProduct = {
  //       OrderProductID: 0,
  //       CategoryID: model.CategoryID,
  //       CategoryName: "Test",
  //       SubCategoryID: model.SubCategoryID,
  //       SubCategoryName: "Test",
  //       ProductID: model.ProductID,
  //       ProductName:  "Test",
  //       OrderQuantity:1,
  //       UnitPrice: model.GStarPrice,
  //       AvailableQuantity: model.StockQuantity,
  //       ProductImage: "",
  //       Quantity: 1,
  //       AllowBackOrder: model.AllowBackOrder,
  //       Total: total,
  //       ProductStatus: 1,
  //       IsDeleted: false,
  //       QuotaTrigger1: model.QuotaTrigger1,
  //       QuotaTrigger2: model.QuotaTrigger2,
  //       IsBackOrder: model.StockQuantity <= 0 ? true : false,
  //       IsGemar: model.IsGemar,
  //       IsPartyDeco: model.IsPartyDeco,
  //       WCProductID: model.WCProductID,
  //       PDWCProductID: model.PDWCProductID,
  //     };

  //     typeOrderProductList.push(newProduct);
  //   });

  //   newHeaderFormData.TypeOrderProductModelList = [
  //     ...typeOrderProductList
  //   ];

  //
  //   let grandTotal = 0;
  //         newHeaderFormData.TypeOrderProductModelList.filter(
  //           (d) => d.IsDeleted === false
  //         ).map(
  //           (current) =>
  //           (grandTotal =
  //             grandTotal + parseFloat(current.Total ? current.Total : 0))
  //         );

  //         newHeaderFormData.ClientID=35;
  //         newHeaderFormData.OrderSourceID=2;

  //         newHeaderFormData.GrandTotal = grandTotal;

  //         setHeaderFormData(newHeaderFormData);

  //         handleSubmit("", true);

  //   }

  //   });

  //}

  return (
    <Fragment>
      <PageTitle
        activeMenu={editOrderID > 0 ? "Edit Order" : "Add Order"}
        motherMenu="Order"
      />
      <ToastContainer />
      <div className="row">
        <div className="col-xl-12">
          <div className="card">
            <div className="card-header">
              <h4 className="card-title header-title">
                {editOrderID > 0 ? "Edit Order" : "Add Order"}
              </h4>
              <div className="envelope-order-left">
                {!orderDetail.WCCustomerMessage ||
                  (orderDetail.WCCustomerMessage !== null && (
                    <div>
                      {editOrderID && editOrderID > 0 ? (
                        <div
                          onClick={() => handleMessageOrder(orderDetail)}
                          title={
                            (orderDetail.WCCustomerMessage &&
                              orderDetail.CustomerMessage === null) ||
                            !orderDetail.CustomerMessage
                              ? "Add Message"
                              : "View Message"
                          }
                          // className="shadow btn-xs sharp me-1 cursor-pointer"
                          className={
                            (orderDetail.WCCustomerMessage &&
                              orderDetail.CustomerMessage === null) ||
                            !orderDetail.CustomerMessage
                              ? " shadow btn-xs sharp me-1 cursor-pointer"
                              : "btn grey-btn-color shadow btn-xs sharp me-1"
                          }
                          style={{
                            backgroundColor: "#d14e1bd1",
                            color: "#fff",
                          }}
                        >
                          <i className="fas fa-dolly fa-envelope"></i>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  ))}
                {/* <Button variant="btn btn-primary" onClick={handleBulkAdd}>
                  Bulk Add
                </Button> */}

                <Button variant="btn btn-danger" onClick={handlechanges}>
                  Back
                </Button>
              </div>
            </div>

            <div className="card-body">
              <div className="row">
                <div className="col-md-4 mb-2">
                  <label className="text-black font-w700">
                    Client Name<span className="text-danger">*</span>
                  </label>
                  <Select
                    classNamePrefix={"custom_select_css"}
                    name="ClientID"
                    value={newHeaderFormData.ClientOption}
                    options={clientDrpList}
                    onChange={(event) => handleDrpChange(event, "ClientID")}
                    isDisabled={
                      newHeaderFormData.TypeOrderProductModelList.filter(
                        (d) => d.IsDeleted === false
                      ).length > 0
                        ? true
                        : false
                    }
                    styles={
                      submitted && !newHeaderFormData.ClientOption ? styles : ""
                    }
                  />
                </div>
                <div className="col-md-4 mb-2">
                  <label className="text-black font-w700">
                    Client Type / Quota
                  </label>
                  <input
                    type="text"
                    name="ClientTypeAndQuota"
                    placeholder="Client Type / Quota"
                    value={newHeaderFormData.ClientTypeAndQuota}
                    className="form-control readonly_css"
                    readOnly={true}
                  ></input>
                </div>

                <div className="col-md-4 mb-3">
                  <label className="text-black font-w700">
                    Order Source<span className="text-danger">*</span>
                  </label>
                  <Select
                    classNamePrefix={"custom_select_css"}
                    name="OrderSourceID"
                    value={newHeaderFormData.OrderSourceOption}
                    options={orderSourceDrpList}
                    onChange={(event) =>
                      handleDrpChange(event, "OrderSourceID")
                    }
                    isDisabled={newHeaderFormData.OrderID > 0 ? true : false}
                    styles={
                      submitted && !newHeaderFormData.OrderSourceOption
                        ? styles
                        : ""
                    }
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-md-4 mb-3">
                  <label className="text-black font-w700">
                    Product<span className="text-danger">*</span>
                  </label>
                  <Select
                    classNamePrefix={"custom_select_css"}
                    name="ProductID"
                    value={newHeaderFormData.ProductOption}
                    options={productList}
                    onChange={(event) => handleDrpChange(event, "ProductID")}
                    isDisabled={
                      newHeaderFormData.IndexId >= 0 &&
                      newHeaderFormData.TypeOrderProductModelList[
                        newHeaderFormData.IndexId
                      ].OrderProductID > 0
                        ? true
                        : false
                    }
                    styles={
                      submitted && !newHeaderFormData.ProductOption
                        ? styles
                        : ""
                    }
                  />
                </div>
                <div className="col-md-4 mb-3">
                  <label className="text-black font-w700">
                    Category<span className="text-danger">*</span>
                  </label>
                  <Select
                    classNamePrefix={"custom_select_css"}
                    name="CategoryID"
                    value={newHeaderFormData.CategoryOption}
                    options={categoryDrpList}
                    //onChange={(event) => handleDrpChange(event, "CategoryID")}
                    isDisabled={true}
                    styles={
                      submitted && !newHeaderFormData.CategoryOption
                        ? styles
                        : ""
                    }
                  />
                </div>

                <div className="col-md-4 mb-3">
                  <label className="text-black font-w700">
                    Sub Category<span className="text-danger">*</span>
                  </label>
                  <Select
                    classNamePrefix={"custom_select_css"}
                    name="SubCategoryID"
                    value={newHeaderFormData.SubCategoryOption}
                    options={subCategoryList}
                    //onChange={(event) => handleDrpChange(event, "SubCategoryID")}
                    isDisabled={true}
                    styles={
                      submitted && !newHeaderFormData.SubCategoryOption
                        ? styles
                        : ""
                    }
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-md-3 mb-3">
                  <label className="text-black font-w700">
                    Available Quantity (A.Q+O.Q)
                  </label>
                  <input
                    type="text"
                    name="AvailableQuantity"
                    placeholder="Available Quantity"
                    value={fNumber(newHeaderFormData.AvailableQuantity)}
                    readOnly={true}
                    className="form-control readonly_css"
                  ></input>
                </div>

                <div className="col-md-3 mb-3">
                  <label className="text-black font-w700">Unit Price</label>
                  <input
                    type="text"
                    name="PriceID"
                    placeholder="Price"
                    value={fCurrency(newHeaderFormData.Price)}
                    className="form-control readonly_css"
                    readOnly={true}
                  ></input>
                </div>
                <div className="col-md-3 mb-3">
                  <label className="text-black font-w700">
                    Order Quantity<span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    name="OrderQuantity"
                    maxLength={6}
                    onChange={(e) => handleChange(e)}
                    onBlur={(e) => handleBlur(e)}
                    placeholder="Order Quantity"
                    value={newHeaderFormData.OrderQuantity}
                    className={`form-control  ${
                      submitted &&
                      (!newHeaderFormData.OrderQuantity ||
                        (newHeaderFormData.OrderQuantity &&
                          parseInt(newHeaderFormData.OrderQuantity) === 0)) &&
                      "border-danger"
                    }`}
                  ></input>
                </div>
                <div className="col-md-3 mb-3">
                  <label className="text-black font-w700">
                    Allotted Quantity
                  </label>
                  <input
                    type="text"
                    name="AllotedQuantity"
                    maxLength={6}
                    onChange={(e) => handleChange(e)}
                    onBlur={(e) => handleBlur(e)}
                    className={`form-control  ${
                      submitted &&
                      !newHeaderFormData.AllotedQuantity &&
                      "border-danger"
                    }`}
                    placeholder="Alloted Quantity"
                    value={newHeaderFormData.AllotedQuantity}
                  ></input>
                </div>
              </div>
              <div className="row">
                <div className="col-md-4 mb-3">
                  <label className="text-black font-w700">Product Image</label>
                  <div className="col-md-9 mb-3">
                    {newHeaderFormData.ProductImage ? (
                      <img
                        style={{ height: "170px" }}
                        className="card-img-top"
                        src={
                          newHeaderFormData.ProductImage &&
                          newHeaderFormData.ProductImage
                            ? REACT_APP_API_IMAGE_URL +
                              newHeaderFormData.ProductImage
                            : ""
                        }
                        alt="Card_image_cap"
                      />
                    ) : (
                      <img
                        style={{ height: "170px" }}
                        className="card-img-top"
                        src={emptyImage}
                        alt="Card_image_cap"
                      />
                    )}
                  </div>
                </div>
              </div>

              <div className="col-12">
                <button
                  type="button"
                  onClick={() => handleAddProduct()}
                  style={{ float: "right" }}
                  className="btn btn-primary mb-2"
                >
                  {newHeaderFormData.IndexId === -1
                    ? "Add Product"
                    : "Update Product"}
                </button>
              </div>
            </div>

            <div className="card-body">
              <div className="col-12">
                <div className="card">
                  <div className="card-header">
                    <h4 className="card-title">Product Details</h4>
                  </div>
                  <div className="card-body">
                    {IsShowWarningText && (
                      <div
                        className="p-2 w-100 insufficient-product-badge d-flex justify-content-start align-items-center gap-2"
                        style={{ borderRadius: "4px" }}
                      >
                        <i
                          className="fa fa-exclamation-triangle"
                          aria-hidden="true"
                        ></i>
                        <span className="fs-6">
                          Insufficient product quantity. Kindly modify
                        </span>
                      </div>
                    )}

                    <div className="table-responsive">
                      <div id="job_data" className="dataTables_wrapper">
                        <table
                          className="display w-100 dataTable "
                          id="example5"
                          role="grid"
                          aria-describedby="example5_info"
                        >
                          <thead>
                            <tr role="row">
                              <th
                                className="sorting_asc"
                                style={{ width: "177px" }}
                              >
                                Category
                              </th>
                              <th
                                className="sorting"
                                style={{ width: "200px" }}
                              >
                                Sub Category
                              </th>
                              <th
                                className="sorting"
                                style={{ width: "200px" }}
                              >
                                Product
                              </th>
                              <th
                                className="sorting"
                                style={{ width: "128px" }}
                              >
                                Unit Price
                              </th>
                              <th className="sorting" style={{ width: "46px" }}>
                                Quantity
                              </th>
                              <th className="sorting" style={{ width: "46px" }}>
                                Total
                              </th>
                              <th className="sorting" style={{ width: "46px" }}>
                                Action
                              </th>
                            </tr>
                          </thead>

                          <tbody>
                            {newHeaderFormData &&
                            newHeaderFormData.TypeOrderProductModelList &&
                            newHeaderFormData.TypeOrderProductModelList.length >
                              0 ? (
                              <>
                                {newHeaderFormData &&
                                  newHeaderFormData.TypeOrderProductModelList.map(
                                    (inputField, index) => {
                                      return (
                                        inputField.IsDeleted === false && (
                                          <Fragment
                                            key={`${inputField}~${index}`}
                                          >
                                            <tr
                                              className={`odd ${
                                                inputField.IsAPIError === true
                                                  ? "insufficient-product-row"
                                                  : ""
                                              }`}
                                              role="row"
                                              title={`${
                                                inputField.IsAPIError === true
                                                  ? "Order product not completed"
                                                  : ""
                                              }`}
                                            >
                                              <td className="sorting_1">
                                                {/* <i
                                                  title={`${
                                                    inputField.IsAPIError ===
                                                    true
                                                      ? "Order product not completed"
                                                      : ""
                                                  }`}
                                                  className={`${
                                                    inputField.IsAPIError ===
                                                    true
                                                      ? "fa fa-circle text-danger me-1"
                                                      : ""
                                                  }`}
                                                ></i>{" "} */}
                                                {inputField.CategoryName}
                                              </td>
                                              <td>
                                                {inputField.SubCategoryName}
                                              </td>
                                              <td>
                                                {" "}
                                                <i
                                                  className={`${
                                                    inputField.IsBackOrder ===
                                                    true
                                                      ? "fa fa-circle text-warning me-1"
                                                      : ""
                                                  }`}
                                                ></i>{" "}
                                                {inputField.ProductName}
                                              </td>
                                              <td>
                                                {fCurrency(
                                                  inputField.UnitPrice
                                                )}
                                              </td>
                                              <td>
                                                {fNumber(inputField.Quantity)}
                                              </td>
                                              <td>
                                                {fCurrency(inputField.Total)}
                                              </td>
                                              <td>
                                                <div className="d-flex">
                                                  <Link
                                                    className="btn btn-primary shadow btn-xs sharp me-1"
                                                    onClick={(e) =>
                                                      handleEditOrder(
                                                        index,
                                                        inputField.OrderProductID
                                                      )
                                                    }
                                                    title="Edit"
                                                  >
                                                    <i className="fas fa-pen"></i>
                                                  </Link>
                                                  {newHeaderFormData.IndexId ===
                                                    -1 && (
                                                    <Link
                                                      className="btn btn-danger shadow btn-xs sharp"
                                                      onClick={(e) =>
                                                        handleRemoveOrder(
                                                          index,
                                                          inputField.OrderProductID
                                                        )
                                                      }
                                                      title="Delete"
                                                    >
                                                      <i className="fa fa-trash"></i>
                                                    </Link>
                                                  )}
                                                </div>
                                              </td>
                                            </tr>
                                          </Fragment>
                                        )
                                      );
                                    }
                                  )}
                              </>
                            ) : (
                              <tr>
                                <td colSpan="11" className="norecordfound">
                                  <span>No Records Found</span>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <h4>
                    <b style={{ float: "right", padding: "0px 92px 0px 0px" }}>
                      Grand Total : {fCurrency(newHeaderFormData.GrandTotal)}
                    </b>
                  </h4>
                </div>
              </div>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-12">
                  <button
                    type="button"
                    onClick={(event) => handleSubmit(event, true)}
                    style={{ float: "right" }}
                    className="btn btn-primary mb-2"
                  >
                    Submit
                  </button>
                  {orderDetail.IsOrderCreated !== true && (
                    <button
                      type="button"
                      onClick={(event) => handleSubmit(event, false)}
                      style={{ float: "right", marginRight: "6px" }}
                      className="btn btn-primary mb-2"
                    >
                      Save Temporary
                    </button>
                  )}

                  {/* <button type="button" style={{ float: "right" }} className="btn btn-danger shadow mb-2 me-2">
                                        Cancel
                                    </button> */}
                </div>
              </div>
            </div>
          </div>
        </div>
        <Modal
          className="fade bd-example-modal-lg"
          show={isCancelModal}
          size="md"
        >
          <Modal.Header>
            <Modal.Title>Order Message</Modal.Title>
            <Button
              variant=""
              className="btn-close"
              //  onClick={() => handleClosePopup()}
              onClick={() => setCancelModal(false)}
            ></Button>
          </Modal.Header>
          <Modal.Body>
            <form>
              <div className="row">
                <label className="text-black font-w500">Customer</label>
                <div className="contact-name">
                  <div
                    style={{ padding: "8px", wordBreak: "break-word" }}
                    className="validation-text"
                  >
                    <strong>{newHeaderFormData.WCCustomerMessage} </strong>
                  </div>
                </div>

                <div className="col-md-12 mb-6">
                  <label className="text-black font-w500">
                    Gemar <span className="text-danger">*</span>
                  </label>
                  <div className="contact-name">
                    <input
                      type="text"
                      className={`form-control width-modify ${
                        orderDetail.CustomerMessage && "readonly_css "
                      } ${submitted && "border-danger"}`}
                      name="CustomerMessage"
                      required="required"
                      onChange={handleOrderChange}
                      value={newHeaderFormData.CustomerMessage}
                      placeholder="Enter the Message"
                      maxLength={50}
                      readOnly={orderDetail.CustomerMessage ? true : false}
                    />
                    <span className="validation-text"></span>
                  </div>
                </div>
              </div>
            </form>
          </Modal.Body>

          <Modal.Footer>
            <Button
              variant="danger light"
              onClick={() => setCancelModal(false)}
            >
              Close
            </Button>
            {((orderDetail.CustomerMessage &&
              orderDetail.CustomerMessage === null) ||
              !orderDetail.CustomerMessage) && (
              <Button
                variant=""
                onClick={handleMessageSubmit}
                // onClick={handleAddFormSubmit}
                className="btn btn-primary"
              >
                Submit
              </Button>
            )}
          </Modal.Footer>
        </Modal>
      </div>
      {loader}
    </Fragment>
  );
};

export default AddEditOrder;
